import React, { Component } from 'react'
import { ReactTypeformEmbed } from 'react-typeform-embed'
import Modal from 'react-awesome-modal'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'

class Nps extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: false
    }
    setTimeout(() => {
      this.setState({ showModal: this.props.closeDonation })
    }, 1000)
  }
  render () {
    return process.env.REACT_APP_NPS ? (
      <Modal
        width='80%'
        height='70%'
        effect='fadeInUp'
        visible={this.state.showModal}
        onClickAway={() => this.setState({ showModal: false })}
      >
        <div className='pos-absolute zindex-high r-0 t-2'>
          <Button
            name={'Close'}
            className='btn btn-double btn-flat btn-icon-only btn-icon'
            iconName='icon_close icon-sm'
            text=''
            onClick={() => this.setState({ showModal: false })}
          />
        </div>
        <ReactTypeformEmbed url={this.props.urlNps || process.env.REACT_APP_NPS} />
      </Modal>
    )
      : ''
  }
}

Nps.propTypes = {
  closeDonation: PropTypes.bool,
  urlNps: PropTypes.string
}

export default Nps



// WEBPACK FOOTER //
// ./src/features/Nps/index.js